mutation StopPoll($pollId: ID!) {
  poll: StreamToolsStopPoll(pollId: $pollId) {
    pollId
    status
    youtubeVotesEnabled
    stoppedAt
    graceEndsAt
  }
}
